import { createSelector } from 'reselect';

import { getCompany } from './company.selectors';

export const selectEmailSignature = createSelector(
  getCompany,
  ({ emailSignature }) => emailSignature,
);

export const selectEmailSignatureTemplate = createSelector(
  selectEmailSignature,
  emailSignature => emailSignature?.template?.value,
);
